import Vue from 'vue'
import Main from './Main.vue'
import VueI18n from 'vue-i18n'

import {router,vuetify} from './plugins';
import store from './store';
import '@/components';

//import messages from './i18n/messages';

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  console.error(err);
  Vue.prototype.$apiCall(`mutation ClientError($input:ClientErrorInput!) {
                           logClientError(input:$input)
                         }`, {input:{query:'VUE ERROR', variables:'',
                                     error:`"${err.message}" occurred in ${vm.$options.__file??'unknown component'}: ${info}\n${err.stack}`}});
}

import commonPurtrakList from '@/mixins/commonPurtrakList'
Vue.mixin(commonPurtrakList);

Vue.config.devtools = true;

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') ?? 'en', // set locale
//  messages, // set locale messages
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(Main),
  el: '#app',
  i18n
}); // .$mount('#app')

//Vue.use(VueI18n);